import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { homePath, allowedPath } from "../lib/api";

export default function ProtectedRoute({ children, requireSuperadmin }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === undefined)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="num text-muted-foreground animate-pulse">Loading ledger…</div>
      </div>
    );
  if (user === null) return <Navigate to="/login" state={{ from: location }} replace />;

  if (requireSuperadmin && user.platform_role !== "superadmin")
    return <Navigate to="/dashboard" replace />;
  if (!requireSuperadmin && user.platform_role === "superadmin")
    return <Navigate to="/admin" replace />;
  if (!allowedPath(user, location.pathname))
    return <Navigate to={homePath(user)} replace />;

  return children;
}
